import React, { useEffect, useState } from "react";
import "../Bec/bec.scss";

import {
  Card,
  CardTitle,
  CardText,
  CardSubtitle,
  CardGroup,
  Row,
  Col,
  Table,
} from "reactstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  BarElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

import { Bar, Doughnut } from "react-chartjs-2";
import axios from "axios";
import * as FaIcons from "react-icons/fa";

const calcularTasaYPrediccion = (aniosB) => {
  const tasas = [];

  // Añadimos una tasa de 0 para el primer año
  tasas.push(0);

  // Calcula tasas año a año desde el segundo
  for (let i = 1; i < aniosB.length; i++) {
    const valorAnterior = aniosB[i - 1];
    const valorActual = aniosB[i];
    if (valorAnterior !== 0) {
      const tasa = (valorActual - valorAnterior) / valorAnterior;
      tasas.push(tasa);
    } else {
      tasas.push(0);
    }
  }
};

const Analisis = () => {
  // Estado
  const [dataRes, setDataRes] = useState([]);
  // const [dataRes2, setDataRes2] = useState([]);
  const [anios, setAnios] = useState([]);
  const [aniosB, setAniosB] = useState([]);
  const [ciudad, setCiudad] = useState([]);
  const [region, setRegion] = useState([]);
  const [pruLoData, setPruLoData] = useState([]);

  // Función para obtener datos
  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";
  async function peticionResumenDatos() {
    try {
      const res = await axios.get(`${baseUrl}?action=getResumen`);
      // console.log("Datos recibidos:", res.data);
      setDataRes(res.data);
      // Años y conteos
      if (res.data.anios && Array.isArray(res.data.anios)) {
        const aniosArray = res.data.anios.map((item) => item.anio_sup_bec);
        const conteoArray = res.data.anios.map((item) =>
          parseInt(item.conteo, 10)
        );
        setAnios(aniosArray);
        setAniosB(conteoArray);
      }

      // Ciudades y regiones
      if (res.data.ciudades && Array.isArray(res.data.ciudades)) {
        setCiudad(res.data.ciudades.map((item) => item.ciu_sup_bec));
        setRegion(res.data.ciudades.map((item) => parseInt(item.conteo, 10)));
      }

      // Datos pru_lo
      if (res.data.pru_lo && Array.isArray(res.data.pru_lo)) {
        setPruLoData(res.data.pru_lo);
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  }

  // Ejecutar al cargar
  useEffect(() => {
    peticionResumenDatos();
  }, []);
  useEffect(() => {
    if (anios.length > 1 && aniosB.length === anios.length) {
      calcularTasaYPrediccion(anios, aniosB);
    }
  }, [anios, aniosB]);
  ////GRAFICO BARRAS
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    Title,
    Tooltip,
    ArcElement,
    LineElement,
    Tooltip,
    Legend
  );

  /////
  const data = {
    labels: anios,
    datasets: [
      {
        label: "Inscritos",
        backgroundColor: "rgba(49, 51, 124, 0.7)",
        borderColor: "rgb(49, 51, 124)",
        borderWidth: 3,
        hoverBackgroundColor: "rgba(49, 51, 124, 0.8)",
        hoverBorderColor: "rgba(49, 51, 124)",
        data: aniosB,
      },
    ],
  };
  const opciones = {
    maintainAspectRatio: false,
    responsive: true,
    ticks: {
      font: {
        size: 15,
        weight: "bold",
      },
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 15,
            weight: "bold",
          },
        },
      },
    },
  };
  /////GRAFICO PIE
  const dataPie = {
    labels: ciudad,
    datasets: [
      {
        label: "# miembros",
        data: region,
        backgroundColor: [
          "rgba(217, 83, 79, 0.6)",
          "rgba(10, 49, 67, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
          "rgba(255, 159, 64, 0.6)",
        ],
        borderColor: [
          "rgba(217, 83, 79, 0.8)",
          "rgba(10, 49, 67, 0.8)",
          "rgba(255, 206, 86, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(153, 102, 255, 0.8)",
          "rgba(255, 159, 64, 0.8)",
        ],
        hoverBackgroundColor: [
          "rgba(217, 83, 79, 0.9)",
          "rgba(10, 49, 67, 0.9)",
          "rgba(255, 206, 86, 0.9)",
          "rgba(75, 192, 192, 0.9)",
          "rgba(153, 102, 255, 0.9)",
          "rgba(255, 159, 64, 0.9)",
        ],
        hoverBorderColor: [
          "rgba(217, 83, 79)",
          "rgba(10, 49, 67)",
          "rgba(255, 206, 86)",
          "rgba(75, 192, 192)",
          "rgba(153, 102, 255)",
          "rgba(255, 159, 64)",
        ],
        borderWidth: 3,
      },
    ],
  };
  const opcionesPie = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        labels: {
          font: {
            size: 15,
            weight: "bold",
          },
        },
      },
    },
  };

  return (
    <div id="main_content">
      <div className="tra">
        <CardGroup className="row g-3">
          {/* Primera tarjeta */}
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Card className="h-100" style={{ color: "black" }}>
              <div className="row g-0 h-100">
                {/* Contenido principal */}
                <div className="col-8 d-flex flex-column justify-content-between p-2">
                  <CardTitle tag="h5">Cuentas</CardTitle>
                  <CardSubtitle className="mb-2 text-muted" tag="h6">
                    Becarios
                  </CardSubtitle>
                  <CardText>
                    {Object.keys(dataRes).length > 0 &&
                    dataRes.total_usuarios !== undefined ? (
                      <b style={{ color: "rgb(33 33 185)" }}>
                        {dataRes.total_usuarios}
                      </b>
                    ) : (
                      <span>No hay datos disponibles</span>
                    )}
                  </CardText>
                </div>
                <div className="icono-tarjeta">
                  <FaIcons.FaUserGraduate />
                </div>
              </div>
            </Card>
          </div>
          {/* Segunda tarjeta */}
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Card className="h-100" style={{ color: "black" }}>
              <div className="row g-0 h-100">
                <div className="col-8 d-flex flex-column justify-content-between p-2">
                  <CardTitle tag="h5">Cuentas</CardTitle>
                  <CardSubtitle className="mb-2 text-muted" tag="h6">
                    Personal
                  </CardSubtitle>
                  <CardText>
                    {Object.keys(dataRes).length > 0 &&
                    dataRes.total_personal !== undefined ? (
                      <b style={{ color: "rgb(33 33 185)" }}>
                        {dataRes.total_personal}
                      </b>
                    ) : (
                      <span>No hay datos disponibles</span>
                    )}
                  </CardText>
                </div>
                <div className="icono-tarjeta">
                  <FaIcons.FaUserTie />
                </div>
              </div>
            </Card>
          </div>
          {/* Tercera tarjeta */}
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Card className="h-100" style={{ color: "black" }}>
              <div className="row g-0 h-100">
                {/* Contenido principal */}
                <div className="col-8 d-flex flex-column justify-content-between p-2">
                  <CardTitle tag="h5">Datos</CardTitle>
                  <CardSubtitle className="mb-2 text-muted" tag="h6">
                    Postulantes
                  </CardSubtitle>
                  <CardText>
                    {Object.keys(dataRes).length > 0 &&
                    dataRes.total_postulantes !== undefined ? (
                      <b style={{ color: "rgb(33 33 185)" }}>
                        {dataRes.total_postulantes}
                      </b>
                    ) : (
                      <span>No hay datos disponibles</span>
                    )}
                  </CardText>
                </div>
                <div className="icono-tarjeta">
                  <FaIcons.FaLevelDownAlt />
                </div>
              </div>
            </Card>
          </div>
          {/* Cuarta tarjeta */}
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Card className="h-100" style={{ color: "black" }}>
              <div className="row g-0 h-100">
                <div className="col-8 d-flex flex-column justify-content-between p-2">
                  <CardTitle tag="h5">Informes</CardTitle>
                  <CardSubtitle className="mb-2 text-muted" tag="h6">
                    Entregados
                  </CardSubtitle>
                  <CardText>
                    {Object.keys(dataRes).length > 0 &&
                    dataRes.total_informes !== undefined ? (
                      <b style={{ color: "rgb(33 33 185)" }}>
                        {dataRes.total_informes}
                      </b>
                    ) : (
                      <span>No hay datos disponibles</span>
                    )}
                  </CardText>
                </div>
                <div className="icono-tarjeta">
                  <FaIcons.FaReadme />
                </div>
              </div>
            </Card>
          </div>
        </CardGroup>
        {/* // */}
        <Row>
          <Col sm="4">
            <Card body>
              <CardTitle tag="h5">Histórico de registros:</CardTitle>
              <CardText
                className="text-center"
                style={{ color: "rgb(33 33 185)" }}
              >
                <b>Becarios</b>
              </CardText>
              <div style={{ width: "100%", height: "400px" }}>
                <Bar data={data} options={opciones} />
              </div>
            </Card>
          </Col>
          <Col sm="4">
            <Card body>
              <CardTitle tag="h5">Registro según región:</CardTitle>
              <CardText
                className="text-center"
                style={{ color: "rgb(33 33 185)" }}
              >
                <b>Becarios</b>
              </CardText>
              <div style={{ width: "100%", height: "400px" }}>
                <Doughnut data={dataPie} options={opcionesPie} />
              </div>
            </Card>
          </Col>
          <Col sm="4">
            <Card body>
              <CardTitle tag="h5">Actividades recientes:</CardTitle>
              <div className="table-responsive" style={{ height: "450px" }}>
                <Table id="tabl">
                  <thead id="stahead">
                    <tr className="text-center">
                      <th>#</th>
                      <th>Usuario</th>
                      <th>Detalle</th>
                      <th>Fecha</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pruLoData.length > 0 ? (
                      pruLoData.map((usr, nu) => (
                        <tr className="text-center" key={usr.id_l}>
                          <td>{nu + 1}</td>
                          <td>{usr.usr_mod}</td>
                          <td>{usr.detalle}</td>
                          <td>{usr.fechaA}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No hay actividades recientes
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Analisis;
